import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";
import { connect } from "react-redux";

import { capitalize, currentLanguage } from "helpers";
import WP from "WP";

import MobileActivityFeatures from "./MobileActivityFeatures";
import SmartLink from "partials/SmartLink";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Button from "partials/Button";
import FavoriteButton from "partials/FavoriteButton";

import Clock from "icons/ClockIcon";
import Calender from "icons/CalenderIcon";

export class ActivityFeatures extends Component {
  getDate(date) {
    return moment(new Date(date).toUTCString()).format("Do MMM");
  }

  getSlug(productCode) {
    if (
      this.props.availability &&
      this.props.availability.fromDate &&
      this.props.availability.fromDate.length
    ) {
      return `https://svalbardadventures.travelize24.com/clientfiles/svalbardbooking.asp?WebSiteUser=ssWeb&productcode=${productCode}&showpicture=no&showtext=no&lang=${
        currentLanguage() === "no" ? "NO" : "UK"
      }`;
    } else {
      return `https://svalbardadventures.travelize24.com/clientfiles/svalbardbooking.asp?WebSiteUser=ssWeb&productcode=${productCode}&showpicture=no&showtext=no&lang=${
        currentLanguage() === "no" ? "NO" : "UK"
      }`;
    }
  }

  render() {
    const { isMobile, data } = this.props;

    return (
      <div>
        {!isMobile ? (
          <Container grid>
            <StyledGridElement colStart={7} colEnd={10} align='center'>
              <Calender />
              <p>
                {this.getDate(data.acf.from_date)} -{" "}
                {this.getDate(data.acf.to_date)}
              </p>
            </StyledGridElement>
            <StyledGridElement colStart={10} colEnd={12} align='center'>
              <Clock />
              <p>
                {data.acf.duration} {WP.trans.hours}
              </p>
            </StyledGridElement>
            <StyledGridElement colStart={13} colEnd={16} colSpan align='center'>
              <p>
                {capitalize(WP.trans.perPerson)} NOK {data.acf.price}
              </p>
            </StyledGridElement>
            <StyledGridElement
              colStart={16}
              colEnd={20}
              colSpan
              justify='center'
            >
              <SmartLink
                to={this.getSlug(data.acf.travelize_id)}
                target='blank'
              >
                <StyledButton>{WP.trans.addToBooking}</StyledButton>
              </SmartLink>
            </StyledGridElement>
            <StyledGridElement colStart={21} place={["center", "start"]}>
              <FavoriteButton sort={data.type} item={data} />
            </StyledGridElement>
          </Container>
        ) : (
          <GridElement colStart={1} colEnd={8}>
            <MobileActivityFeatures
              data={data}
              getDate={this.getDate}
              getSlug={(id) => this.getSlug(id)}
            />
          </GridElement>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  availability: state.availability,
});

export default connect(mapStateToProps, null)(ActivityFeatures);

const StyledButton = styled(Button)``;

const StyledGridElement = styled(GridElement)`
  display: flex;
  align-items: center;

  svg {
    margin-right: ${(props) => props.theme.spacing.contentS};
    fill: ${(props) => props.theme.colors.text};
  }
`;
